/* IB-7 Warenkorb: Cart AJAX API und Section Rendering API (Vanilla JS, defer).
   - Formulare mit Klasse js-ib7-add werden per /cart/add.js gesendet, ohne JS funktioniert das normale Formular.
   - Danach wird die Section cart-drawer neu geladen und der Inhalt von #cart-drawer .drawer__panel ersetzt.
   - Mengen per /cart/change.js, Duo-Upgrade: Duo hinzufügen, danach Einzelzeilen entfernen.
   Der Drawer selbst (Öffnen, Schließen) liegt in assets/ib7-v2.js (window.IB7.openDrawer). */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  function drawer() { return document.getElementById('cart-drawer'); }

  function errorText(data) {
    var d = drawer();
    var fallback = (d && d.getAttribute('data-error-generic')) || '';
    if (data && typeof data.description === 'string' && data.description) return data.description;
    if (data && typeof data.message === 'string' && data.message) return data.message;
    return fallback;
  }

  function request(path, options) {
    return fetch(root + path, options).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) { var err = new Error(errorText(data)); err.isCartError = true; throw err; }
        return data;
      });
    });
  }

  function postJson(path, body) {
    return request(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function setBusy(state) {
    busy = state;
    var d = drawer();
    if (d) {
      d.querySelectorAll('button, a[data-qty-change]').forEach(function (el) {
        if (state) {
          el.setAttribute('data-was-disabled', el.disabled ? 'true' : 'false');
          if (el.tagName === 'BUTTON') el.disabled = true;
          el.setAttribute('aria-disabled', 'true');
        } else {
          if (el.getAttribute('data-was-disabled') === 'false' && el.tagName === 'BUTTON') el.disabled = false;
          el.removeAttribute('aria-disabled');
          el.removeAttribute('data-was-disabled');
        }
      });
      var panel = d.querySelector('.drawer__panel');
      if (panel) panel.setAttribute('aria-busy', state ? 'true' : 'false');
    }
  }

  function updateCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  function showError(message) {
    var d = drawer();
    var el = d && d.querySelector('[data-cart-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  /* Lädt die Section neu und ersetzt den Panel-Inhalt. */
  function refresh() {
    return Promise.all([
      fetch(root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
    ]).then(function (results) {
      var html = results[0] && results[0]['cart-drawer'];
      var cart = results[1];
      var d = drawer();
      if (html && d) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('#cart-drawer .drawer__panel');
        var panel = d.querySelector('.drawer__panel');
        if (next && panel) panel.innerHTML = next.innerHTML;
      }
      updateCounts(cart.item_count || 0);
    });
  }

  function fail(err) {
    showError(err && err.message ? err.message : (drawer() && drawer().getAttribute('data-error-generic')) || '');
  }

  function openCart() {
    if (window.IB7 && typeof window.IB7.openDrawer === 'function') window.IB7.openDrawer('cart-drawer');
  }

  /* ---------- Produktformulare ---------- */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('js-ib7-add')) return;
    event.preventDefault();
    if (busy) return;

    var submitter = event.submitter || form.querySelector('[type="submit"]');
    var formData = new FormData(form);
    var message = '';

    setBusy(true);
    if (submitter) { submitter.disabled = true; submitter.setAttribute('aria-busy', 'true'); }

    request('cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData })
      .catch(function (err) { message = err && err.message ? err.message : errorText(); })
      .then(refresh)
      .catch(function () { if (!message) message = errorText(); })
      .then(function () {
        setBusy(false);
        if (submitter) { submitter.disabled = false; submitter.removeAttribute('aria-busy'); }
        showError(message);
        openCart();
      });
  });

  /* ---------- Drawer: Menge, Entfernen, Upgrade ---------- */
  document.addEventListener('click', function (event) {
    var d = drawer();
    if (!d) return;
    var upgrade = event.target.closest('[data-upgrade-duo]');
    var change = event.target.closest('[data-qty-change]');
    if ((!upgrade && !change) || !d.contains(event.target)) return;
    event.preventDefault();
    if (busy) return;

    if (upgrade) {
      var addId = upgrade.getAttribute('data-add-id');
      var keys = (upgrade.getAttribute('data-remove-key') || '').split(',').filter(Boolean);
      setBusy(true);
      showError('');
      postJson('cart/add.js', { id: Number(addId), quantity: 1 })
        .then(function () {
          return keys.reduce(function (chain, key) {
            return chain.then(function () { return postJson('cart/change.js', { id: key, quantity: 0 }); });
          }, Promise.resolve());
        })
        .then(refresh)
        .then(function () { setBusy(false); })
        .catch(function (err) { return refresh().catch(function () {}).then(function () { setBusy(false); fail(err); }); });
      return;
    }

    var line = change.getAttribute('data-line-index');
    var row = change.closest('.cart-line');
    var current = row ? Number(row.getAttribute('data-line-qty')) : 0;
    var delta = change.getAttribute('data-qty-change');
    var quantity = delta === 'remove' ? 0 : Math.max(0, current + Number(delta));
    var focusSelector = quantity > 0 ? '[data-line-index="' + line + '"][data-qty-change="' + delta + '"]' : null;

    setBusy(true);
    showError('');
    postJson('cart/change.js', { line: Number(line), quantity: quantity })
      .then(refresh)
      .then(function () { setBusy(false); })
      .catch(function (err) { return refresh().catch(function () {}).then(function () { setBusy(false); fail(err); }); })
      .then(function () {
        var dd = drawer();
        var target = dd && (focusSelector ? dd.querySelector(focusSelector) : dd.querySelector('.icon-btn[data-close]'));
        if (target) target.focus();
      });
  });
})();
